import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  TimePicker,
  Select,
} from 'antd';
import moment from 'moment';

import HoverHelp from '../../../common/HoverHelp';
import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';

const MINUTE_INCREMENT_OPTIONS = [
  {
    label: '1 minute',
    value: 1,
  },
  {
    label: '15 minutes',
    value: 15,
  },
  {
    label: '30 minutes',
    value: 30,
  },
];

const TIME_FORMAT = 'hh:mm a';
const TWENTY_FOUR_HOUR_TIME_FORMAT = 'HH:mm';

function DateTimeSelectionCheckbox({
  setHideDate,
  setHideTime,
  setUse24HourTime,
  setMinuteIncrement,
  setDefaultTime,
  configProps,
}) {
  const {
    hideDate,
    hideTime,
    use24HourTime,
    minuteIncrement,
    defaultTime,
  } = configProps;

  const timeMoment = defaultTime ? moment(defaultTime) : null;

  return (
    <>
      <Row style={{ marginTop: 20 }} gutter={10}>
        <Col>
          Date Time Options:
        </Col>
        <Col>
          <HoverHelp
            placement="topRight"
            content={(
              <div style={{ width: 250 }}>
                Toggle which parts of the Date/Time you would like to hide from the user
              </div>
            )}
          />
        </Col>
      </Row>
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        onChange={setHideDate}
        value={hideDate}
        label="Hide Date"
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        onChange={setHideTime}
        value={hideTime}
        label="Hide Time"
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        onChange={setUse24HourTime}
        value={use24HourTime}
        label="Use 24 Hour Format"
        disabled={hideTime}
      />
      {!hideTime && (
        <>
          <Row align="middle" style={{ marginTop: 10 }} gutter={10}>
            <Col>
              Minute Increment:
            </Col>
            <Col>
              <Select
                options={MINUTE_INCREMENT_OPTIONS}
                value={minuteIncrement || MINUTE_INCREMENT_OPTIONS[0].value}
                onChange={setMinuteIncrement}
                style={{ marginRight: 56, minWidth: 120, textAlign: 'right' }}
              />
            </Col>
          </Row>
          <Row align="middle" style={{ marginTop: 10 }} gutter={10}>
            <Col>
              Default Time:
            </Col>
            <Col>
              <HoverHelp
                placement="topRight"
                content={(
                  <div style={{ width: 250 }}>
                    Set the initial value for the time picker when opened.
                  </div>
                )}
              />
            </Col>
            <Col>
              <TimePicker
                style={{ width: '100%' }}
                value={timeMoment}
                onChange={setDefaultTime}
                minuteStep={minuteIncrement || MINUTE_INCREMENT_OPTIONS[0].value}
                format={use24HourTime ? TWENTY_FOUR_HOUR_TIME_FORMAT : TIME_FORMAT}
                use12Hours={!use24HourTime}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

/* eslint-disable react/forbid-prop-types */
DateTimeSelectionCheckbox.propTypes = {
  setHideDate: PropTypes.func.isRequired,
  setHideTime: PropTypes.func.isRequired,
  setUse24HourTime: PropTypes.func.isRequired,
  setMinuteIncrement: PropTypes.func.isRequired,
  setDefaultTime: PropTypes.func.isRequired,
  configProps: PropTypes.object,
};

DateTimeSelectionCheckbox.defaultProps = {
  configProps: {},
};

export default DateTimeSelectionCheckbox;
